<template>
    <div>
        <h4><i class="fa fa-paperclip mr-2" aria-hidden="true"></i>{{ $lang('Załączniki') }}</h4>
        <hr class="colorgraph">
        <table v-if="filesObjects.length > 0" class="table simple-table table-striped table-sm">
            <thead class="thead-dark">
            <tr>
                <th scope="col">{{ $lang('Nazwa') }}</th>
                <th scope="col">{{ $lang('Akcje') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="file in filesObjects">
                <td :data-title="$lang('Nazwa')" style="overflow-wrap: anywhere;"> {{ file.filename }}</td>
                <td :data-title="$lang('Akcje')">
                    <a target="_blank" class="mr-3"
                       :href="route_show_file+'/'+file.hash+'?filename='+file.filename">{{ $lang('Podgląd') }}</a>
                    <a class="mr-3" href="#" data-toggle="modal"
                       v-on:click="selectedFile=file"
                       data-target="#delete_modal"
                       v-if="can_delete"
                    >{{ $lang('Usuń') }}</a>
                </td>
            </tr>
            </tbody>
        </table>
        <p v-else>{{ $lang('Brak plików') }}</p>


        <!--        MODAL-->
        <div class="modal fade" id="delete_modal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Usunięcie pliku') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ $lang('Czy na pewno chcesz usunąć plik?') }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default"
                                data-dismiss="modal">{{ $lang('Nie') }}
                        </button>
                        <button class="btn btn-primary" v-on:click="deleteFile" data-dismiss="modal">
                            {{ $lang('Tak') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import ShowNotification from "../mixins/show-notification";


export default {
    name: 'files-table-component',
    mixins: [ShowNotification],
    props: {
        files: {type: Array|Object, required: true},
        route_delete_file: {type: String, required: true},
        route_show_file: {type: String, required: true},
        can_delete: {type: Boolean, required: true},
        object_id: {type: Number|null, required: false, default: null}
    },
    data() {
        return {
            selectedFile: null,
            filesObjects: this.files,
        }
    },
    methods: {
        deleteFile() {
            const self = this;
            let data = {};
            data.hash = this.selectedFile.hash;
            data.objectId = this.object_id;
            axios.delete(this.route_delete_file, {data})
                .then(function () {
                    self.removeSelectedFile();
                    self.showNotification('success', 'Pomyślnie usunięto plik!');
                })
                .catch(function (error) {
                    self.showNotification('error', 'Nie udało się usunąć pliku!');
                });
        },
        removeSelectedFile() {
            this.filesObjects = this.filesObjects.filter(fileObject => {
                return fileObject.hash !== this.selectedFile.hash;
            });
        }
    },
}
</script>
